import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Typography,
  withStyles
} from '@material-ui/core';
import React from 'react';
import { withRouter } from 'react-router';
import { compose } from 'recompose';
import BackButton from '../../components/atoms/BackButton';
import RegisterButton from '../../components/atoms/RegisterButton';
import usageTypes from '../../constants/UsageType';

const styles = {
  root: {
    position: 'absolute',
    width: '85%',
    height: 'auto',
    maxHeight: '80%',
    top: '5%',
    left: '2%',
    backgroundColor: '#fff',
    padding: 28,
    overflow: 'scroll',
    outline: 'none'
  },
  mainPaper: {
    position: 'relative',
    margin: '1px 0px 10px',
    padding: '10px 26px 10px 26px'
  },
  pageTitle: {
    margin: '20px 0px 0px',
    paddingLeft: 20,
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  description: {
    color: '#707070',
    margin: '20px 0px 0px'
  },
  subTitle: {
    margin: '20px 0px 0px',
    paddingTop: 2,
    textAlign: 'left',
    backgroundColor: '#fff'
  },
  divider: {
    margin: '20px 0px'
  },
  detailTable: {
    width: 'auto'
  },
  tableCellItem: {
    border: '2px solid #ffffff',
    backgroundColor: '#e0e0e0'
  },
  tableCellData: {
    border: '2px solid #ffffff'
  },
  textField100: {
    padding: '0px 5px 0px 5px',
    width: '100px'
  },
  textField: {
    padding: '0px 5px 0px 5px',
    width: '300px'
  },
  textFieldLong: {
    padding: '0px 5px 0px 5px',
    width: '500px'
  },
  editTable: {
    width: 'auto'
  },
  tableCell: {
    border: '2px solid #ffffff'
  },
  selectControl: {
    width: '100%'
  }
};

const enhance = compose();

const Main = enhance(
  ({
    connectSystemName,
    shopName,
    menuName,
    username,
    ticketName,
    usedAt,
    classes,
    ticketId,
    backAction,
    registerAction,
    menuPrice,
    usedTicketNum,
    submitData,
    usageType
  }) => {
    const USAGE_TYPE_VOUCHER = usageTypes[1].id;

    return (
      <div className={classes.root}>
        <Typography variant="h6">メニュー登録確認</Typography>
        <Paper className={classes.mainPaper} elevation={1}>
          <Table className={classes.detailTable}>
            <TableBody>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  システム名
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {connectSystemName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  ユーザー名
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {username}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  チケット種別
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {ticketName}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>店舗名</TableCell>
                <TableCell className={classes.tableCellData}>
                  {shopName}
                </TableCell>
              </TableRow>
              {ticketId !== 4 && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    メニュー名
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {menuName}
                  </TableCell>
                </TableRow>
              )}
              {menuName === '金額指定利用メニュー' && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    利用税込金額
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {`${menuPrice}円`}
                  </TableCell>
                </TableRow>
              )}
              {(ticketId === 4 ||
                !submitData.menuId ||
                usageType === USAGE_TYPE_VOUCHER) && (
                <TableRow>
                  <TableCell className={classes.tableCellItem}>
                    消費税区分
                  </TableCell>
                  <TableCell className={classes.tableCellData}>
                    {`${submitData.usedTaxRate * 100}%`}
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.tableCellItem}>個数</TableCell>
                <TableCell className={classes.tableCellData}>
                  {usedTicketNum}
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.tableCellItem}>
                  利用日時
                </TableCell>
                <TableCell className={classes.tableCellData}>
                  {usedAt}
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </Paper>
        <div>
          <BackButton onClickAction={backAction} />
          <RegisterButton onClickAction={registerAction} />
        </div>
      </div>
    );
  }
);

export default withRouter(withStyles(styles)(Main));
